import { render, staticRenderFns } from "./GoogleSpeechToText.vue?vue&type=template&id=bba6f0ba&scoped=true"
import script from "./GoogleSpeechToText.vue?vue&type=script&lang=js"
export * from "./GoogleSpeechToText.vue?vue&type=script&lang=js"
import style0 from "./GoogleSpeechToText.vue?vue&type=style&index=0&id=bba6f0ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba6f0ba",
  null
  
)

export default component.exports